import { render, staticRenderFns } from "./DefaultTextToSpeechControls.vue?vue&type=template&id=ae93e628&"
import script from "./DefaultTextToSpeechControls.vue?vue&type=script&lang=ts&"
export * from "./DefaultTextToSpeechControls.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultTextToSpeechControls.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports